import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CustomImageCachePage } from './custom-image-cache.page';

const routes: Routes = [
  {
    path: '',
    component: CustomImageCachePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomImageCachePageRoutingModule {}
